import InputAdornment from '@mui/material/InputAdornment';
import type { FormTextInputProps } from '@src/common/components/FormTextInput';
import { FormTextInput } from '@src/common/components/FormTextInput';
import type { FieldValues } from 'react-hook-form';

export const MoneyInput = <T extends FieldValues>({
  ...props
}: FormTextInputProps<T> & { readOnly?: boolean }) => {
  return (
    <FormTextInput
      slotProps={{
        input: {
          readOnly: props.readOnly,
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        },
      }}
      disabled={props.readOnly}
      size="small"
      placeholder="00.00"
      noLabel={true}
      {...props}
    />
  );
};
